// @flow

import _ from 'lodash';
import ko from 'rgs-knockout';


ko.extenders.inheritValidation = function (target, parent) {
	target.extend({
		validation: parent.rules(),
	});
};

ko.extenders.followValidation = function (target, master) {
	target.extend({
		validation: {
			validator: () => master.isValid(),
			message: () => master.error(),
		},
	});
	target.isModified = master.isModified;
};

ko.extenders.validationLoggingName = function (target, name) {
	if (!_.isFunction(name)) {
		name = _.constant(name);
	}
	target.validationLoggingName = name;
};
